import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Appointments from './pages/Appointments';
import Gallery from './pages/Gallery';
import AIAssistant from './components/AIAssistant';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import ScrollToTop from './components/ScrollToTop';
import PromoBar from './components/PromoBar';
import PopupAd from './components/PopupAd';
import LuckyDraw from './pages/LuckyDraw';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import FAQ from './pages/FAQ';
import WhatsAppButton from './components/WhatsAppButton';
import './App.css';
import Pricing from './pages/Pricing';
import InstallPWA from './components/InstallPWA';
function App() {
  const [loading, setLoading] = useState(true);

  return (
    <HelmetProvider>
      {loading && <LoadingScreen onComplete={() => setLoading(false)} />}
      {!loading && (
        <Router>
          <ScrollToTop />
          <PromoBar />
          <PopupAd />
          <div className="app">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/appointments" element={<Appointments />} />
              <Route path="/lucky-draw" element={<LuckyDraw />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="*" element={<NotFound />} />
              

            </Routes>
            <WhatsAppButton />
            <AIAssistant />
            <InstallPWA />
            <Footer />
          </div>
        </Router>
      )}
    </HelmetProvider>
  );
}

export default App;